import React from 'react'
import Banner from '../Component/Banner/Banner'
import CoinTable from '../Component/CoinTable'

const Home = () => {
  return (
    <>
      <Banner/>
      <CoinTable/>
    </>
  )
}

export default Home